import React, { useState, useEffect } from "react";
import './SiteLoader.css'
import {
    GetSitePreview
} from './Requests';
import {PulseLoader } from "react-spinners";
import ClientSiteTheme1 from "./ClientSiteTheme1";


  const SiteLoader = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const siteIdFromUrlParam = queryParameters.get("site")
    const [siteId, setSiteId] = useState(siteIdFromUrlParam)
    const [loading, setLoading] = useState(true)
    const [result, setResult] = useState()
    const [siteDetails, setSiteDetails] = useState()
    const [lang, setLang] = useState("en-GB")

    useEffect(() => {
        if (siteId !== null)
            {
                GetSitePreviewWrapper()
            }
      }, []);

    
    function GetSitePreviewWrapper()
    {
        GetSitePreview(siteId).then((res) => {
            if (res.status === 200)
            {
                setSiteDetails(res.data.site)
                setLang(res.data.bookingPortalLanguage)
                setResult("okay")
            } else{
                setResult("bad")
            }

        }).catch((error) => {
            setResult("bad")

        }).finally((f) => {
            setLoading(false)
        })
    }

    return (
    <div>
            {loading?
                <div className="site-loader-container">
        <div className="site-loader-card">
            <PulseLoader 
            color={'#333'}
            loading={loading}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
            />
            </div>
            </div>
            :
            result === "bad"
            ?
    <div className="site-loader-container">
        <div className="site-loader-card">
            <div>
                <h1>Site not found</h1>
                <p>The site you are looking for could not be found, please try again.</p>
            </div>
            </div>
            </div>
            :
            <ClientSiteTheme1 site={siteDetails} lang={lang}/>
            // siteDetails.themeId === 1 ? <ClientSiteTheme1 site={siteDetails} /> : siteDetails.themeId === 2 ? <ClientSiteTheme1 site={siteDetails} /> : <ClientSiteTheme1 site={siteDetails} />
            
            }
    </div>
    );
  };
  
  export default SiteLoader;